import { render, staticRenderFns } from "./Pass.vue?vue&type=template&id=401d6447&scoped=true&"
import script from "./Pass.vue?vue&type=script&lang=js&"
export * from "./Pass.vue?vue&type=script&lang=js&"
import style0 from "./Pass.vue?vue&type=style&index=0&id=401d6447&prod&lang=less&scoped=true&"
import style1 from "../../assets/h5-auth.less?vue&type=style&index=1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d6447",
  null
  
)

export default component.exports